<template>
  <div class="d-flex align-items-center" :class="[width, variant]">
    <div class="dot" :style="{ background: `${iconBackground} !important` }">
      <em
        class="title-icon mt-1"
        :class="icon"
        :style="{ color: iconColor, fontSize: iconSize }"
      />
    </div>
    <div
      class="color-gray-7 font-16 font-weight-bold"
      :class="{ gradient: gradient }"
    >
      {{ title }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'IconView',
  props: {
    title: {
      type: String,
      default: () => '',
    },
    icon: {
      type: String,
      required: true,
    },
    iconBackground: {
      type: String,
      default: () => '',
    },
    iconColor: {
      type: String,
      default: () => 'color-orange',
    },
    iconSize: {
      type: String,
      default: () => '',
    },
    gradient: {
      type: Boolean,
      default: () => false,
    },
    width: {
      type: String,
      default: () => 'w-100',
    },
    variant: {
      type: String,
      default: () => '',
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/shared/scss/config/_colors.scss';
.dot {
  box-shadow: 0px 3px 6px #00000029;
  margin: 2px;
  width: 27px;
  height: 27px;
  border-radius: 50%;
  border-style: solid;
  border-width: 3px;
  border-color: map-get($colors, 'white');
  display: inline-block;
  margin-right: 15px;
  .title-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 2px;
    font-size: 12px;
  }
}

.gradient {
  background: transparent linear-gradient(90deg, #ffffff00 0%, #e2e2e2 100%) 0%
    0% no-repeat padding-box;
  border-radius: 33px;
  padding: 5px 5px;
  padding-right: 20px;
}
</style>
